import { FormatCurrencyForDisplay } from './FormatCurrencyForDisplay';

type LocalizeAmountParams = {
  lang: string;
  amount: number | string;
  currency: string;
  asString?: boolean;
};

export const localizeAmountWithCurrency = ({
  lang,
  amount,
  currency,
  asString = false,
}: LocalizeAmountParams) => {
  const currencyFormatter = FormatCurrencyForDisplay(currency, asString);

  if (asString) {
    return lang === 'en'
      ? `${currencyFormatter} ${amount}`
      : `${amount} ${currencyFormatter}`;
  }

  return lang === 'en' ? (
    <>
      {currencyFormatter} {amount}
    </>
  ) : (
    <>
      {amount} {currencyFormatter}
    </>
  );
};
